export default __webpack_public_path__ + "static/media/07.3d13b109.jpg";